const initialState = {
    isTokenExpired: false,
    authorities: {},
};
export default initialState;